module.exports = __webpack_public_path__ + "img/shrimp_th_new_0007.752de734.png";